import React, { useEffect } from "react";
import PopUp from "../PopUp";
import abTestingManager from "../utils/abTesting";

const Cotizador = () => {
  useEffect(() => {
    // Trackear apertura del cotizador con las variantes activas
    abTestingManager.trackCotizadorOpen();
  }, []);

  return (
    <>
      <PopUp />
    </>
  );
};

export default Cotizador;
